/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PlaylistUpdate } from './PlaylistUpdate';
import {
    PlaylistUpdateFromJSON,
    PlaylistUpdateFromJSONTyped,
    PlaylistUpdateToJSON,
} from './PlaylistUpdate';

/**
 * 
 * @export
 * @interface PlaylistUpdates
 */
export interface PlaylistUpdates {
    /**
     * 
     * @type {Array<PlaylistUpdate>}
     * @memberof PlaylistUpdates
     */
    playlistUpdates?: Array<PlaylistUpdate>;
}

/**
 * Check if a given object implements the PlaylistUpdates interface.
 */
export function instanceOfPlaylistUpdates(value: object): value is PlaylistUpdates {
    let isInstance = true;

    return isInstance;
}

export function PlaylistUpdatesFromJSON(json: any): PlaylistUpdates {
    return PlaylistUpdatesFromJSONTyped(json, false);
}

export function PlaylistUpdatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlaylistUpdates {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'playlistUpdates': !exists(json, 'playlist_updates') ? undefined : ((json['playlist_updates'] as Array<any>).map(PlaylistUpdateFromJSON)),
    };
}

export function PlaylistUpdatesToJSON(value?: PlaylistUpdates | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'playlist_updates': value.playlistUpdates === undefined ? undefined : ((value.playlistUpdates as Array<any>).map(PlaylistUpdateToJSON)),
    };
}

